export default "__VITE_ASSET__De1SJIM7__"